import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators"
import store from ".";
import jwtDecode, { JwtPayload } from "jwt-decode";

@Module({ dynamic: true, store: store, name: 'MetaModule'})
export class Meta extends VuexModule {
  loading = false

  accessToken = ''

  refreshToken = ''

  get allowBusinessLogin() {
    return process.env["VUE_APP_ALLOW_BUSINESS_LOGIN"] === "true"
  }

  get timestamp() {
    return Date.now() / 1000
  }

  get login() {
    return this.accessToken !== "" && this.exp > this.timestamp
  }

  get exp() {
    try {
      const exp = jwtDecode<JwtPayload>(this.accessToken).exp
      return exp == undefined ? 0 : exp
    } catch (error) {
      return 0
    }
  }

  get plan() {
    try {
      // eslint-disable-next-line
      return jwtDecode<any>(this.accessToken)["plan"]
    } catch(error) {
      return ""
    }
  }

  get role(): "owner" | "member" | "viewer" {
    try {
      // eslint-disable-next-line
      const r = jwtDecode<any>(this.accessToken)["role"]
      if (r === "owner" || r === "member") {
        return r
      }
      return "viewer"
    } catch (error) {
      return "viewer"
    }
  }

  get isOwner() {
    return this.role === "owner"
  }

  get isMember() {
    return this.role === "member"
  }

  get isViewer() {
    return this.role === "viewer"
  }

  @Mutation
  updateLoading(loading: boolean) {
    this.loading = loading
  }

  @Mutation
  updateAccessToken(accessToken: string) {
    localStorage.setItem("access_token", accessToken)
    this.accessToken = accessToken
  }
  

  @Mutation
  updateRefreshToken(refreshToken: string) {
    localStorage.setItem("refresh_token", refreshToken)
    this.refreshToken = refreshToken
  }

  @Action
  loadFromStorage() {
    const token = localStorage.getItem("access_token")
    const refreshToken = localStorage.getItem("refresh_token")

    this.updateAccessToken(token ? token: "")
    this.updateRefreshToken(refreshToken ? refreshToken : "")
    
  }
}